<template>
    <v-main class="pa-2" fluid>
        <h1>Pilots</h1>
        <v-row>
            <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on">Add new Pilot</v-btn>
                </template>
                <v-card color="lighten-1">
                    <v-toolbar>
                        <v-toolbar-title>
                            <span class="headline">New Pilot</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-form ref="form" v-model="valid" class="row">
                                    <v-col cols="12" md="12">
                                        <v-text-field label="Name" v-model="editedItem.name" :rules="nameRules" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="12">
                                        <v-text-field label="Weight" v-model="editedItem.weight" :rules="weightRules" required type="number"
                                        ></v-text-field>
                                    </v-col>
                                </v-form>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-data-table
            :headers="headers"
            :items="pilots"
            :items-per-page="50"
            class="elevation-1">
                <template v-slot:item.actions="{ item }">

                <v-btn icon small @click="edit(item)">
                  <v-icon center>mdi-pencil</v-icon> 
                </v-btn>

                <v-btn icon small color="red" @click="deletePilot(item.id)">
                  <v-icon center>mdi-delete-forever</v-icon> 
                </v-btn>

                </template>

                <template v-slot:item.status="{ item }">
                    <v-switch :success="item.status == 1 ? true : false" @change="updateStatus(item)"
                                  v-model="item.status"
                                  inset
                                  :label="getUserSwitchLabel(item.status)"
                            ></v-switch>
                </template>
            </v-data-table>
    </v-main>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
                headers: [
                    { text: '', value: 'data-table-expand' },
                    { text: 'Name', align: 'start', sortable: true, value: 'name', },
                    { text: 'Weight', align: 'start', sortable: true, value: 'weight', },
                    { text: '', align: 'start', sortable: true, value: 'status' },
                    { text: '', align: 'start', sortable: true, value: 'actions' },
                ],

                dialog: false,
                editedIndex: -1,
                valid: true,
                lazy: true,
                isEditing: null,
                editedItem: {
                    name : '',
                    weight : 0,
                    status : 1
                },
                nameRules: [
                    v => !!v || 'Name is required',
                ],
                weightRules: [
                    v => !!v || 'Weight is required',
                ],
            }
        },

        mounted () {
            if( this.pilots.length == 0 )
            this.$store.dispatch('fetchManifestData')
        },


        computed: {
            ...mapState(['pilots']),

            formTitle () {
                return this.editedIndex === -1 ? 'New Pilot' : 'Edit Pilot'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        
        methods: {

            edit(item) { 

                this.editedIndex = this.pilots.indexOf(item);
                this.editedItem = Object.assign({}, item)

                this.dialog = true
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                  
                })
              },


              save () {

                if (this.editedIndex > -1) {


                    axios.put('/api/pilots/' + this.editedItem.id, this.editedItem)
                        .then( response => {

                            Object.assign(this.pilots[this.editedIndex], this.editedItem)
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

                  
                } else {


                    axios.post('/api/pilots', this.editedItem)
                    .then( response => {

                        this.pilots.push(this.editedItem)

                        this.close();
                        
                    })
                    .catch( err => {
                        console.log( err )
                    })
                  
                }

              },

              updateStatus(item) {

                this.editedIndex = this.pilots.indexOf(item)
                this.editedItem = Object.assign({}, item)

                axios.put('/api/pilots/updateStatus/' + this.editedItem.id, this.editedItem)
                        .then( response => {
                            
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })
            },


              deletePilot(id) {

                confirm('Are you sure you want to delete this Pilot? This action can not be undone') && 

                axios.delete('/api/pilots/' + id)
                        .then( response => {

                            const index = this.pilots.map(function (f) { return f.id }).indexOf(id)

                            this.$store.state.pilots.splice(index, 1)
                        })
                        .catch( err => {
                            console.log( err )
                        })
              }
          }
    }
</script>